<template>
	<div class="container">
		<div class="header-bar" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
		</div>
		<div class="title">
			<img :src="titleImg" alt="线下取款预约处理中" />
		</div>
		<div class="content">
			<div class="input-wrapper">
				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						预约取款人：
					</span>
					<input v-model="formData.name" type="text" class="input-field" required placeholder="请输入预约取款人姓名">
				</div>

				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						取款人电话：
					</span>
					<input v-model="formData.phone" type="text" class="input-field" required placeholder="请输入预约取款人手机号码">
				</div>

				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						预约银行名称：
					</span>
					<input v-model="formData.bankname" type="text" class="input-field" required
						placeholder="请输入您预约的银行名称">
				</div>

				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						预约银行地址：
					</span>
					<input v-model="formData.address" type="text" class="input-field" required
						placeholder="请输入您预约的银行地址">
				</div>

				<!-- 添加提交按钮 -->
				<button class="submit-btn" @click="submitAppointment" :disabled="loading">
					修改预约信息
				</button>
			</div>
		</div>
		<div class="appointment-id">
			预约编号：{{ formData.id }}
		</div>
		<div class="tip-text">
			<img :src="textImg" alt="正在预约银行" />
		</div>
		<div class="tip">
			<!-- <img :src="tipImg" alt="温馨提示" /> -->
			温馨提示：<br />
			普通预约通道10个工作日内预约成功<br />
			VIP预约通道5个工作日内预约成功
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import titleImg from '@/assets/withdrawBankCard/appointment_title.png';
	// import tipImg from '@/assets/withdrawBankCard/appointment_tip.png';
	import textImg from '@/assets/withdrawBankCard/appointment_text.png';
	export default {
		name: "AppointmentInfo",
		data() {
			return {
				titleImg: titleImg,
				// tipImg: tipImg,
				textImg: textImg,
				formData: {
					name: '',
					phone: '',
					bankname: '',
					address: '',
					id: ''
				},
				originalData: null, // 原始数据，用于比较是否有修改
				hasCompleteAppointmentInfo: false, // 是否有完整的预约信息
				loading: false, // 提交加载状态
				isPageLoaded: false // 页面是否已加载完成
			};
		},
		created() {
			this.$parent.footer('appointmentWithdrawal', false);
			// 加载已保存的预约信息
			this.loadAppointmentInfo();
		},
		methods: {
			// 加载已保存的预约信息
			loadAppointmentInfo() {
				this.isPageLoaded = false;
				Fetch('/user/get_appointment_info').then((r) => {
					if (r.code === 1 && r.data && Object.keys(r.data).length > 0) {
						// 有完整的预约信息
						this.hasCompleteAppointmentInfo = true;

						// 填充表单数据
						this.formData = {
							name: r.data.name || '',
							phone: r.data.phone || '',
							bankname: r.data.bankname || '',
							address: r.data.address || '',
							id: r.data.id || ''
						};
						// 保存原始数据，用于比较是否有修改
						this.originalData = {
							...this.formData
						};
					} else {
						// 没有完整的预约信息
						this.hasCompleteAppointmentInfo = false;
						this.originalData = null;
					}
				}).catch(() => {
					console.log('加载预约信息失败');
					this.hasCompleteAppointmentInfo = false;
					this.originalData = null;
				}).finally(() => {
					this.isPageLoaded = true;
				});
			},

			// 检查是否有字段被修改
			hasDataChanged() {
				if (!this.originalData) {
					// 首次填写，所有字段都需要
					return true;
				}

				// 检查所有字段是否有修改
				return (
					this.formData.name.trim() !== this.originalData.name ||
					this.formData.phone.trim() !== this.originalData.phone ||
					this.formData.bankname.trim() !== this.originalData.bankname ||
					this.formData.address.trim() !== this.originalData.address
				);
			},

			// 验证表单
			validateForm() {
				// 验证必填字段
				if (!this.formData.name || !this.formData.phone || !this.formData.bankname || !this.formData.address) {
					this.$toast('请填写完整的预约信息');
					return false;
				}

				// 验证姓名（中文姓名，2-10个汉字）
				const nameRegex = /^[\u4e00-\u9fa5]{2,10}$/;
				if (!nameRegex.test(this.formData.name.trim())) {
					this.$toast('请输入正确的姓名（2-10个汉字）');
					return false;
				}

				// 验证手机号格式
				const phoneRegex = /^\d{11}$/;
				if (!phoneRegex.test(this.formData.phone.trim())) {
					this.$toast('请输入正确的手机号码');
					return false;
				}

				// 检查是否有修改
				if (!this.hasDataChanged()) {
					this.$toast('预约信息未修改');
					return false;
				}

				return true;
			},

			// 提交预约信息
			submitAppointment() {
				// 防止重复提交
				if (this.loading) return;

				// 表单验证
				if (!this.validateForm()) {
					return;
				}

				this.loading = true;

				// 调用后端API保存预约信息
				Fetch('/user/save_appointment_withdrawal', {
					name: this.formData.name.trim(),
					phone: this.formData.phone.trim(),
					bankname: this.formData.bankname.trim(),
					address: this.formData.address.trim()
				}).then((r) => {
					this.loading = false;

					if (r.code === 1) {
						this.$toast.success(r.info || '操作成功！');

						// 更新状态和原始数据
						this.hasCompleteAppointmentInfo = true;
						this.originalData = {
							...this.formData
						};
					} else {
						this.$toast(r.info || '提交失败，请重试');
					}
				}).catch((err) => {
					this.loading = false;
					console.error('提交预约信息失败:', err);
					this.$toast('提交失败，请检查网络连接');
				});
			},
		},
	};
</script>

<style scoped>
	.container {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		color: #b22222;
		font-family: "微软雅黑", sans-serif;
		height: 100%;
		width: 10rem;
		background: url(~@/assets/icon/authAccount/bg.png) 100% no-repeat;
		background-size: 100% 100%;
		min-height: 100vh;
	}

	.header-bar {
		width: 100%;
		padding: 4.26667vw;
		display: flex;
		align-items: center;
	}

	.header-bar .back-icon {
		font-size: 6.4vw;
		color: #fff;
		text-shadow: 0 1px .53333vw rgba(0, 0, 0, .3);
	}

	.title {
		width: 90%;
		margin-bottom: 20px;
	}

	.title img {
		width: 100%;
	}

	.tip {
		width: 90%;
		color: #fff;
		font-size: 18px;
		font-weight: 600;
		line-height: 1.6;
		text-align: left;
		margin-bottom: 25px;
		text-shadow: 1px 1px 3px rgba(0, 0, 0, 1);
		background: rgba(255, 255, 255, 0.5);
		padding: 18px 20px;
		border-radius: 12px;
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
		backdrop-filter: blur(5px); /* 添加毛玻璃效果 */
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	.tip img {
		width: 100%;
	}

	.tip-text {
		width: 90%;
		margin-bottom: 20px;
	}

	.appointment-id {
		width: 90%;
		background: rgba(255, 255, 255, 0.5);
		border-radius: 12px;
		padding: 15px;
		margin-bottom: 15px;
		font-size: 18px;
		font-weight: bold;
		color: #333;
		backdrop-filter: blur(5px);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	.content {
		width: 90%;
		background: rgba(255, 255, 255, 0.5);
		border-radius: 12px;
		padding: 20px;
		margin-bottom: 15px;
		box-sizing: border-box;
		backdrop-filter: blur(5px);
		border: 1px solid rgba(255, 255, 255, 0.1);
	}

	.input-wrapper {
		width: 100%;
	}

	.input-group {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		padding: 10px;
		border-bottom: 1px solid #ebedf0;
		position: relative;
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.95);
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
	}

	.input-group:last-child {
		border-bottom: none;
		margin-bottom: 10px;
	}

	.input-label {
		font-size: 14px;
		color: #333;
		font-weight: 500;
		text-align: left;
		position: relative;
		display: flex;
		align-items: center;
		white-space: nowrap;
		width: 100px;
	}

	.required-star {
		color: #ee0a24;
		font-size: 14px;
		margin: 0 2px;
		line-height: 1;
	}

	.input-field {
		flex: 1;
		border: none;
		outline: none;
		font-size: 14px;
		background: transparent;
		color: #333;
		padding: 0;
	}

	.input-field::placeholder {
		color: #969799;
	}

	/* 提交按钮样式 */
	.submit-btn {
		width: 100%;
		height: 44px;
		background: linear-gradient(135deg, #b22222 0%, #d9534f 100%);
		color: white;
		border: none;
		border-radius: 22px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 20px;
		cursor: pointer;
		transition: all 0.3s ease;
		box-shadow: 0 4px 15px rgba(178, 34, 34, 0.3);
	}

	.submit-btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 20px rgba(178, 34, 34, 0.4);
	}

	.submit-btn:active {
		transform: translateY(0);
	}

	.submit-btn:disabled {
		background: linear-gradient(135deg, #ccc 0%, #ddd 100%);
		cursor: not-allowed;
		transform: none;
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
	}

	/* 通道选择弹窗样式 */
	.channel-dialog-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		animation: fadeIn 0.3s ease;
	}

	.channel-dialog {
		width: 85%;
		background: white;
		border-radius: 12px;
		overflow: hidden;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
		animation: slideUp 0.3s ease;
	}

	.channel-dialog-header {
		background: linear-gradient(135deg, #b22222 0%, #d9534f 100%);
		color: white;
		padding: 20px;
		text-align: center;
		position: relative;
	}

	.channel-dialog-title {
		font-weight: 600;
		font-size: 20px;
		margin-bottom: 5px;
	}

	.channel-dialog-sub-title {
		font-size: 14px;
		opacity: 0.9;
	}

	.close-icon {
		position: absolute;
		right: 15px;
		top: 15px;
		font-size: 18px;
		color: white;
		cursor: pointer;
		opacity: 0.8;
	}

	.close-icon:hover {
		opacity: 1;
	}

	.channel-dialog-content {
		padding: 20px;
	}

	.channel-dialog-text {
		text-align: left;
		font-size: 16px;
		color: #333;
		line-height: 1.5;
		margin-bottom: 20px;
	}

	.channel-dialog-text p {
		margin: 5px 0;
	}

	.indent-text {
		text-indent: 2em;
	}

	.channel-dialog-images {
		width: 100%;
	}

	.channel-content {
		margin-bottom: 15px;
	}

	.channel-image {
		width: 100%;
		cursor: pointer;
		transition: transform 0.3s ease;
	}

	.channel-image:hover {
		transform: scale(1.02);
	}

	/* 动画效果 */
	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@keyframes slideUp {
		from {
			transform: translateY(50px) scale(0.9);
			opacity: 0;
		}

		to {
			transform: translateY(0) scale(1);
			opacity: 1;
		}
	}
</style>